import { REHYDRATE } from "redux-persist/constants";
import { FETCH_ALL_COURSES} from "./AdminPanel.action.react";

const initialUsersState = [];

const AllCoursesReducer = (state = initialUsersState, action) => {
    switch (action.type) {
        case REHYDRATE:
            let users = action.payload.users;
            if (users) {
                return users;
            } else {
                return state;
            }
        case FETCH_ALL_COURSES:
            return action.data;
        default:
            return state;
    }
};

export { AllCoursesReducer };
